var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "PH.27a5de56.png","uri@2x": __webpack_public_path__ + "PH.27399433.png","uri@3x": __webpack_public_path__ + "PH.abaf9d88.png",
    width: 42,
    height: 30
});